<template>
  <div class="content">
    <div class="contentPrincipal">
      <div class="myContent">
      <div class="tabContent">
        <div class="tabElement contrat active" @click="changeTab('contrat')">
          <span class="material-icons-sharp"> app_registration </span>Retour
          stock
        </div>
      </div>
</div>
      <div id="contratTab" class="tabElementContent active">
        <div @click="addNewReturnStock" class="buttonAdd">
          <span> Enregistrer une reprise de stock </span>
        </div>
        <div class="contentLists">
          <table class="contentListeTable">
            <thead>
              <tr>
                <th v-for="item in tableHeader" :key="item">{{ item }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                @click="editeReturnStockRow(item)"
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in returnStockData"
                :key="item._id"
              >
              <td>
                  {{ item.status}}
                </td>
                <td>
                  {{ item.product.name }}
                </td>
                <td>
                  {{ item.quantity }}
                </td>
                <td>
                  {{ item.customer.name }}
                </td>
                <td>
                  {{ item.amount }}
                </td>
                <td>
                  {{ item.observation }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
      
      <script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "returnStore",
  components: {},
  data: () => ({
    tableHeader: [
      "Statut",
      "Désignation produit",
      "Quantité",
      "Client",
      "Montant",
      "Observation",
    ],
    isSelecteds: [],
    isSelectedAll: false,
  }),
  computed: {
    ...mapGetters([
      //   "contratData",
      //   "blData",
      //   "conteneurData",
      //   "contenuerAllData",
      //   "storeData",
      "returnStockData",
    ]),
  },
  async mounted() {
    await this.getReturnToStock({});
  },
  methods: {
    ...mapActions([
      "getProduct",
      "getStore",
      "getCustomerList",
      "getReturnToStock",
    ]),
    raccourcirTexte(texte) {
      return texte;
    },
    async addNewReturnStock() {
      this.$emit("show",true)
      const value = {
        modalType: "editeReturnStockRow",
      };
      await this.getProduct({});
      await this.getStore({});
      await this.getCustomerList({});
      //   alert(item);
      this.$emit("editeRowForDash", {
        name: "editeReturnStockRow",
        size: 300,
        value: value,
      });
      this.$emit("show",false)
    },
    async editeReturnStockRow(item) {
      this.$emit("show",true)
      if (!item.isSelected) {
        for (let i = 0; i < this.returnStockData.length; i++) {
          this.returnStockData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.returnStockData);
        await this.getProduct({});
        await this.getStore({});
        await this.getCustomerList({});
        const value = {
          _id: item._id,
          modalType: "editeReturnStockRow",
          product: item.product ? item.product.name : "",
          store: item.store ? item.store.name : "",
          customer: item.customer ? item.customer.name : "",
          quantity: item.quantity,
          amount: item.amount,
          observation: item.observation,
        };
        this.$emit("editeRowForDash", {
          name: "editeReturnStockRow",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show",false)
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async changeTab(tabName) {
      this.$emit("closeAllModal");
      this.$emit("show",true)
      if (tabName === "contrat") {
        await this.getContrat({});
      } else if (tabName === "bl") {
        await this.getBl({});
      } else if (tabName === "conteneur") {
        await this.getConteneurAll({ alreadyInStock: "Oui" });
      } else if (tabName === "conteneurWait") {
        await this.getConteneurAll({ alreadyInStock: "Non" });
      }
      // Masquer tous les onglets
      var tabContents = document.querySelectorAll(".tabElementContent");
      tabContents.forEach(function (tabContent) {
        tabContent.classList.remove("active");
      });

      // Afficher l'onglet sélectionné
      var selectedTab = document.getElementById(tabName + "Tab");
      selectedTab.classList.add("active");

      // Mettre à jour l'état actif des onglets de la barre de navigation
      var tabElements = document.querySelectorAll(".tabElement");
      tabElements.forEach(function (tabElement) {
        tabElement.classList.remove("active");
      });

      var selectedTabElement = document.querySelector(".tabElement." + tabName);
      selectedTabElement.classList.add("active");
      this.$emit("show",false)
    },
  },
};
</script>
      